import { combineReducers } from 'redux';
import { assistantReducer } from './assistantReducer';
import { collectionReducer } from './collectionReducer';

const lastActionReducer = (state: any = null, action: any) => {
    return action;
};

export const rootReducer = combineReducers({
    assistant: assistantReducer,
    lastAction: lastActionReducer,
    collection: collectionReducer,
});

export type RootState = ReturnType<typeof rootReducer>;